import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ConfigService } from '@servicios/config.service';
import * as enums from '@enums/enums'
import { AssayAnaliteService } from '@servicios/assay/assayAnalite.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { dialogData } from '@interfaces/dialog-data.interfase';
import { MatDialog } from '@angular/material/dialog';
import { NotificacionesService } from '@servicios/notificaciones.service';
import { FormAssayAnalitesComponent } from '../form-assay-analites/form-assay-analites.component';
import { GetAssayAnalite_assayAnalite, GetAssaysAnalites } from '@interfaces/operation-result-types';
import { AssayService } from '@servicios/assay/assay.service';
import { roundNumber } from 'app/_sharedFuctions/shared-functions';
import { AssayAnaliteOrderComponent } from '../assay-analite-order/assay-analite-order.component';
import { QueryRef } from 'apollo-angular';
import { AssayAnalitesCopyDialogComponent } from '../assay-analites-copy-dialog/assay-analites-copy-dialog.component';
import { TableDinamicService } from '@servicios/dinamic-components/table-dinamic/table-dinamic.service';
import { LoadOptionsService } from '@servicios/load_options/load_options.service';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MatchModeTextOptions } from '@helpers/matchModeOptions';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-table-assay-analites',
  templateUrl: './table-assay-analites.component.html',
  standalone: false,
  providers: [DialogService]
})
export class TableAssayAnalitesComponent implements OnInit, OnDestroy {
  constructor(
    public configService: ConfigService,
    private aas: AssayAnaliteService,
    public as: AssayService,
    private dialog: MatDialog,
    public dialogService: DialogService,
    private ns: NotificacionesService,
    private TDS: TableDinamicService,
    private opts: LoadOptionsService,
    private confirmationService: ConfirmationService
  ) { }

  @Input() parentSignals: Observable<enums.Signals>
  assay = this.as.idSelected

  selectItemEvent: Subject<void> = new Subject()
  isLoading = false
  isLoadingData = false
  title = this.configService.selectedLanguage.analite + 's'
  parentIsSaved = false
  subscriptions = new Subscription()
  @Output() assayCost: EventEmitter<number> = new EventEmitter()
  cualitativeOptions = [
    { name: 'Cuantitativo', value: false },
    { name: 'Cualitativo', value: true }
  ]

  MatchModeTextOptions = MatchModeTextOptions;

  enums = enums;

  confirmDelete() {
    this.openConfirm(enums.mensajes.confirmarEliminar);
  }

  selectedAnalite: GetAssayAnalite_assayAnalite | null = null;
  tableData: GetAssayAnalite_assayAnalite[] = [];

  onSelectionChanged() {
    this.aas.idSelected = this.selectedAnalite;
    this.selectItemEvent.next()
  };

  tableData$: QueryRef<GetAssaysAnalites>

  ngOnInit(): void {
    this.aas.assaySelected = this.assay
    this.tableData$ = this.aas.getAll(this.assay.id)

    this.isLoading = true

    let tableData$ = this.tableData$.valueChanges.subscribe({
      next: value => {
        this.tableData = value.data.assayAnalites
        let assayCost = this.calculateAssayCost(this.tableData)
        this.assayCost.emit(roundNumber(assayCost, 2))
        this.isLoading = false
      }
    })

    let parentSingnalsSub$ = this.parentSignals.subscribe({
      next: signal => {
        switch (signal) {
          case enums.Signals.PARENT_IS_SAVED:
            this.parentIsSaved = true;
            this.selectItemEvent.next()
            break;
        }
      }
    })

    this.subscriptions.add(parentSingnalsSub$)
    this.subscriptions.add(tableData$)
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
    this.aas.assaySelected = undefined
  }

  /* Button State Helpers */
  canCreate(): boolean {
    return !(!this.parentIsSaved || this.isLoadingData || this.as.modeForm == enums.estadoFormulario.registroMostrar);
  }

  canEdit(): boolean {
    return !(!this.parentIsSaved || this.isLoadingData || !this.aas.idSelected?.id || this.as.modeForm == enums.estadoFormulario.registroMostrar);
  }

  canDelete(): boolean {
    return !(!this.parentIsSaved || this.isLoadingData || !this.aas.idSelected?.id || this.as.modeForm == enums.estadoFormulario.registroMostrar);
  }

  canOrder(): boolean {
    return !(!this.parentIsSaved || this.isLoadingData);
  }

  canCopy(): boolean {
    return !(!this.parentIsSaved || this.isLoadingData);
  }

  /* DIALOGS */
  //Open dialog
  openForm(data?: dialogData): void {

    if (!data) {
      this.aas.modeForm = enums.estadoFormulario.registroNuevo
      data = { data: undefined, payload: { assay: this.assay, analites: this.tableData } }
    }

    let header = '';
    switch (this.aas.modeForm) {
      case enums.estadoFormulario.registroNuevo:
        header = this.configService.selectedLanguage.newAssayAnalite;
        break;
      case enums.estadoFormulario.registroEdicion:
        header = this.configService.selectedLanguage.editAssayAnalite;
        break;
      case enums.estadoFormulario.registroMostrar:
        header = this.configService.selectedLanguage.assayAnalite;
        break;
    }

    const ref = this.dialogService.open(FormAssayAnalitesComponent, {
      header: header,
      width: '80vw',
      height: '85vh',
      showHeader: true,
      maximizable: true,
      styleClass: 'assay-analite-modal-dialog',
      style: { "width": "80vw", "max-width": "1200px", "height": "85vh", "max-height": "85vh", "overflow": "hidden", "border-radius": "12px" },
      contentStyle: { "overflow": "hidden", "padding": "0", "border-bottom-left-radius": "12px", "border-bottom-right-radius": "12px" },
      baseZIndex: 10000,
      modal: true,
      data: data,
      closable: true,
      closeOnEscape: true
    });

    ref.onClose.subscribe((value: boolean) => {
      this.selectedAnalite = null;
      this.aas.idSelected = undefined;
      this.selectItemEvent.next();
      if (value) {
        this.tableData$.refetch()
      }
      this.opts.updateOpts('assaysOptsSG', [])
      this.opts.updateOpts('assaysGroupsOptsSG', [])
    })
  };

  // Open dialog for edition.
  openEditShow(onlyShowMode: boolean) {
    if (this.aas.idSelected?.id == undefined) return;
    if (onlyShowMode) this.aas.modeForm = enums.estadoFormulario.registroMostrar
    if (!onlyShowMode) this.aas.modeForm = enums.estadoFormulario.registroEdicion;
    this.openForm({ data: this.aas.idSelected.id, payload: { assay: this.assay, analites: this.tableData } })
  };

  openConfirm(_message: enums.mensajes) {
    this.confirmationService.confirm({
      message: _message,
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sí',
      rejectLabel: 'No',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.delete();
        this.opts.updateOpts('assaysGroupsOptsSG', []);
      }
    });
  };

  openAssayAnaliteOrder() {
    const ref = this.dialogService.open(AssayAnaliteOrderComponent, {
      header: 'Ordenar Determinaciones',
      width: '500px',
      modal: true,
      data: { analites: this.tableData, assayId: this.assay.id }
    })

    ref.onClose.subscribe({
      next: value => {
        if (value) this.tableData$.refetch()
      }
    })
  }

  openTableCopyAssayAnalitesConfig() {
    this.TDS.TableCopyAssayAnalitesConfig.grid.flex.selection_kind = 'ANALITES'
    this.TDS.TableCopyAssayAnalitesConfig.grid.style = undefined;
    const ref = this.dialogService.open(AssayAnalitesCopyDialogComponent, {
      header: 'Seleccionar Determinaciones para Copiar',
      width: '1000px',
      position: 'right',
      styleClass: 'sidebar-dialog',
      modal: true,
      data: { tableConfig: this.TDS.TableCopyAssayAnalitesConfig }
    })

    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.tableData$.refetch()
          this.opts.updateOpts('assaysOptsSG', [])
          this.opts.updateOpts('assaysGroupsOptsSG', [])
        }
      }
    })
  }

  delete() {
    this.isLoading = true;
    this.aas.delete(this.aas.idSelected.id)
      .subscribe(
        {
          next: res => {
            this.aas.idSelected = undefined
            this.selectedAnalite = null;
            this.selectItemEvent.next()
            this.isLoading = false
            this.ns.emitMessage('Elemento eliminado')
            this.tableData$.refetch()
            this.opts.updateOpts('assaysOptsSG', [])
            this.opts.updateOpts('assaysGroupsOptsSG', [])
          },
          error: err => {
            this.isLoading = false
            throw err
          }
        }
      );
  }

  calculateAssayCost(data: GetAssayAnalite_assayAnalite[]) {
    return data.reduce((assayCost, value) => {
      return value.active ? assayCost += value.cost : assayCost
    }, 0)
  }

  cellDoubleClicked($event: any) {
    this.aas.idSelected = $event.data
    this.openEditShow(false)
  }

  showCloneButton() {
    return this.configService.appSettings.frontend?.forms?.assay_analite?.clone?.active || false
  }

}
